import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import sanitizeHtml from "../lib/sanitizeHtml";

export default function IdgPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setPage(null);
    setErr(null);
    api.get(`/idg/pages/by-slug/${slug}`)
      .then((r) => setPage(r.data))
      .catch((e) => setErr(e?.response?.status === 404 ? "Pagina nu a fost găsită." : "Eroare la încărcare."));
  }, [slug]);

  // SEO: set document.title whenever page changes (must run unconditionally)
  useEffect(() => {
    if (!page) return;
    const prev = document.title;
    document.title = page.meta_title || page.title;
    return () => { document.title = prev; };
  }, [page]);

  if (err) return (
    <div className="text-center py-20" data-testid="idg-page-error">
      <h1 className="tf-heading text-3xl text-white mb-2">404</h1>
      <p className="text-zinc-400 text-sm tf-mono mb-6">{err}</p>
      <Link to="/" className="tf-btn-primary tf-clip-btn">Înapoi acasă</Link>
    </div>
  );
  if (!page) return <div className="text-zinc-500 text-center py-20 tf-mono">Se încarcă...</div>;

  return (
    <article className={`idg-page idg-page-${page.template} max-w-4xl mx-auto`} data-testid="idg-public-page">
      <header className="mb-6 pb-6 border-b border-white/5">
        <h1 className="tf-heading text-4xl md:text-5xl font-bold uppercase tracking-widest">{page.title}</h1>
        {page.excerpt && <p className="text-zinc-400 mt-3 text-base">{page.excerpt}</p>}
      </header>
      <div
        className="idg-page-content prose prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content || "") }}
        data-testid="idg-page-content"
      />
    </article>
  );
}
